// app/javascript/widget/ads.ts — распознавание платного клика по адресу посадочной.
//
// Рекламные системы сами дописывают к ссылке свою метку, и это единственный
// надёжный признак: реферер не годится — с рекламы Яндекс приходит как
// yandex.ru, ровно как и с органической выдачи.

/** Метки, которые ставит только реклама.
 *
 *  yclid — Яндекс Директ, ybaip — Яндекс Бизнес (автоматическая реклама, свой
 *  yclid она НЕ ставит), gclid — Google Ads.
 *
 *  ysclid и etext сюда НЕ входят: их Яндекс дописывает и к обычной выдаче, и
 *  вся органика посчиталась бы платной. */
const PAID_PARAMS = ['yclid', 'ybaip', 'gclid'];

/** Разметка кампании вручную: метку клика не всегда сохраняют, а utm_medium
 *  переживает редиректы и остаётся в адресе. */
const PAID_MEDIUMS = ['cpc', 'cpm', 'ppc', 'paid', 'banner'];

/** Пришёл ли посетитель по платному клику.
 *
 *  @param search строка запроса посадочной страницы (window.location.search).
 */
export function hasPaidMarker(search: string): boolean {
  let params: URLSearchParams;
  try {
    params = new URLSearchParams(search ?? '');
  } catch {
    return false;
  }
  if (PAID_PARAMS.some((name) => params.has(name))) return true;

  const medium = (params.get('utm_medium') ?? '').trim().toLowerCase();
  return PAID_MEDIUMS.includes(medium);
}
